import baseHttpMethods from './baseHttpMethods';
import { collectPagedResource as collectPagedResourceMethod } from './collectPagedResource';
import urljoin from 'url-join';

const reporterUrl = window.env.PAPI_EE_REPORTER || urljoin(window.env.API_GATEWAY_URL, 'papi-ee-reporter');

export const { patch, get, post, httpDelete } = baseHttpMethods(reporterUrl);

export const collectPagedResource = collectPagedResourceMethod(reporterUrl);
